
import { RevButton } from '@ds/components/Button'
import { RevCard } from '@ds/components/Card'
import { RevLink } from '@ds/components/Link'
import { RevRating } from '@ds/components/Rating'
import { IconEcologicDark } from '@ds/icons/IconEcologicDark'
import { IconFastDark } from '@ds/icons/IconFastDark'
import { IconGoodPricesDark } from '@ds/icons/IconGoodPricesDark'
import { IconSecuredDark } from '@ds/icons/IconSecuredDark'

import { getGlobalRateRequest } from '@internal-reviews/helpers'
import { REVIEWS_TYPES } from '@internal-reviews/helpers/constants'
import { logReviewsError } from '@reviews/helpers'
import { ROUTES } from '@router'

import translations from './Presentation.translations'

export default {
  components: {
    RevButton,
    RevCard,
    RevLink,
    RevRating,
  },
  data() {
    return {
      globalRate: {},
    }
  },
  async fetch() {
    try {
      const { payload } = await this.$store.dispatch(
        'http/request',
        getGlobalRateRequest({
          type: REVIEWS_TYPES.ALL,
        }),
      )

      this.globalRate = payload
    } catch (err) {
      logReviewsError({ tags: ['HomePage'], err })
    }
  },
  computed: {
    translations: () => translations,
    ROUTES: () => ROUTES,
    shouldDisplayRates() {
      return (
        this.globalRate.reviewsCount >= 10 && this.globalRate.averageRate >= 4
      )
    },
    hasAverageRate() {
      return (
        this.globalRate.averageRate !== undefined &&
        this.globalRate.averageRate !== null
      )
    },
    presentationList() {
      return [
        {
          icon: IconFastDark,
          title: this.$t(translations.block1Title),
          text: this.$t(translations.block1Text),
        },
        {
          icon: IconGoodPricesDark,
          title: this.$t(translations.block2Title),
          text: this.$t(translations.block2Text),
        },
        {
          icon: IconSecuredDark,
          title: this.$t(translations.block3Title),
          text: this.$t(translations.block3Text),
        },
        {
          icon: IconEcologicDark,
          title: this.$t(translations.block4Title),
          text: this.$t(translations.block4Text),
        },
      ]
    },
  },
}
